import DeleteVendorContainer from "./DeleteVendorContainer";
export default DeleteVendorContainer;
